// const ThirdPartyAppScript = function() {
//     function ThirdPartyAppScript() {
//         this.load()
//     }
//     ThirdPartyAppScript.prototype.load = function() {
//         var _ = this;
//         let loaded = false;
//         window.addEventListener("scroll", function() {
//             if(window.scrollY > 10 && !loaded) {
//                 let chatscript = this.document.createElement("script");
//                 chatscript.id = 'gorgias-chat-widget-install-v3';
//                 chatscript.src = "https://config.gorgias.chat/bundle-loader/01GYCCQ5PC3MSBB0CBXZ38Z5HR?source=shopify1click";
//                 document.body.append(chatscript);
//                 let stampedscript = document.createElement("script");
//                 stampedscript.src = "https://cdn1.stamped.io/files/widget.min.js?shop=kiva-wellness.myshopify.com";
//                 document.body.append(stampedscript);
//                 let klaviyoscript = document.createElement("script");
//                 klaviyoscript.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RstYp2";
//                 document.body.append(klaviyoscript);
//                 loaded = true;
//             }
//         })
//         window.addEventListener("mousemove", function() {
//             if(window.scrollY > 10 && !loaded) {
//                 let chatscript = this.document.createElement("script");
//                 chatscript.id = 'gorgias-chat-widget-install-v3';
//                 chatscript.src = "https://config.gorgias.chat/bundle-loader/01GYCCQ5PC3MSBB0CBXZ38Z5HR?source=shopify1click";
//                 document.body.append(chatscript);
//                 let stampedscript = document.createElement("script");
//                 stampedscript.src = "https://cdn1.stamped.io/files/widget.min.js?shop=kiva-wellness.myshopify.com";
//                 document.body.append(stampedscript);
//                 let klaviyoscript = document.createElement("script");
//                 klaviyoscript.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RstYp2";
//                 document.body.append(klaviyoscript);
//                 loaded = true;
//             }
//         })
//         window.addEventListener("touchstart", function() {
//             if(window.scrollY > 10 && !loaded) {
//                 let chatscript = this.document.createElement("script");
//                 chatscript.id = 'gorgias-chat-widget-install-v3';
//                 chatscript.src = "https://config.gorgias.chat/bundle-loader/01GYCCQ5PC3MSBB0CBXZ38Z5HR?source=shopify1click";
//                 document.body.append(chatscript);
//                 let stampedscript = document.createElement("script");
//                 stampedscript.src = "https://cdn1.stamped.io/files/widget.min.js?shop=kiva-wellness.myshopify.com";
//                 document.body.append(stampedscript);
//                 let klaviyoscript = document.createElement("script");
//                 klaviyoscript.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RstYp2";
//                 document.body.append(klaviyoscript);    
//                 loaded = true;
//             }
//         })
//     }
//     ThirdPartyAppScript = new ThirdPartyAppScript;
// }
// ThirdPartyAppScript();

(function () {
  let loaded = false;

  function loadScripts() {
    if (loaded) return;
    loaded = true;

    if (!document.getElementById('gorgias-chat-widget-install-v3')) {
      const chatScript = document.createElement('script');
      chatScript.id = 'gorgias-chat-widget-install-v3';
      chatScript.src = 'https://config.gorgias.chat/bundle-loader/01GYCCQ5PC3MSBB0CBXZ38Z5HR?source=shopify1click';
      chatScript.async = true;
      document.body.appendChild(chatScript);
    }

    if (!window.StampedFn) {
      const stampedScript = document.createElement('script');
      stampedScript.src = 'https://cdn1.stamped.io/files/widget.min.js?shop=kiva-wellness.myshopify.com';
      stampedScript.async = true;
      document.body.appendChild(stampedScript);
    }

    if (!window._klOnsite) {
      const klaviyoScript = document.createElement('script');
      klaviyoScript.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RstYp2';
      klaviyoScript.async = true;
      document.body.appendChild(klaviyoScript);
    }

    window.removeEventListener('scroll', triggerLoad);
    window.removeEventListener('mousemove', triggerLoad);
    window.removeEventListener('touchstart', triggerLoad);
  }

  function triggerLoad() {
    if (window.scrollY > 10) {
      loadScripts();
    }
  }

  window.addEventListener('scroll', triggerLoad, { passive: true });
  window.addEventListener('mousemove', triggerLoad, { passive: true });
  window.addEventListener('touchstart', triggerLoad, { passive: true });
})();
